<script setup lang="ts">
import Button from '@/components/Button.vue'
import { computed } from 'vue'
import {
  EventCreatePayload,
  EventType,
} from '@/modules/expert/events/schemas/schemas'
import { useDisplay } from 'vuetify'
import attachIcon from '@/assets/icons/green/attach.svg'

const { mobile } = useDisplay()
const isMobile = computed(() => mobile.value)

const props = defineProps<{
  name?: string
  corpValue?: boolean
  eventValue?: EventType | EventCreatePayload
  terms?: string | File | null
  privacy?: string | File | null
}>()

const emits = defineEmits<{
  (e: 'delete'): void
  (e: 'open'): void
  (e: 'upload', event: Event): void
}>()

const corporatePolicy = computed(() =>
  props.corpValue
    ? `${import.meta.env.VITE_API_URL}/resources/${props.privacy}`
    : `${import.meta.env.VITE_API_URL}/resources/${props.terms}`
)

const hasTerms = computed(() => {
  if (props.eventValue?.terms !== null && props.terms !== null) return true
  else return false
})

const hasPrivacy = computed(() => {
  if (props.corpValue && props.privacy !== null) return true
  else return false
})

function handleFileChange(event: Event) {
  const input = event.target as HTMLInputElement

  if (input.files && input.files.length > 0) {
    emits('upload', event)
  }
  input.value = ''
}
</script>

<template>
  <div v-if="!isMobile" class="w-100 d-flex mt-n12 mb-6 flex-row-reverse">
    <Button
      class="align-self-center primaryOutline"
      style="height: 28px"
      @click="emits('open')"
    >
      {{ $t('corporate.detail.appendTerms') }}
    </Button>
    <input
      id="inputFileTerms"
      type="file"
      name="inputFileTerms"
      accept="application/pdf"
      class="d-none"
      @change="handleFileChange"
    />
  </div>
  <div class="d-flex flex-column" :class="isMobile ? 'mt-n4' : ''">
    <p v-if="props.corpValue" class="text-caption">
      {{ $t('corporate.detail.explanationAboutPrivacyAndDataPolicy') }}
    </p>
    <div
      v-if="props.corpValue ? hasPrivacy : hasTerms"
      class="d-flex align-center pa-4 flex-space-between w-100 bg-grey-lighten-5 mb-3"
      style="height: 68px"
    >
      <img :src="attachIcon" height="24px" width="24px" class="mr-4" />
      <div style="width: 99%" class="font-weight-light text-body-1 py-4">
        {{ $t('corporate.detail.attachedTerms') }}
      </div>
      <div
        style="height: 30px; width: 30px"
        class="icon-green d-flex align-center mr-2 justify-center"
      >
        <a :href="corporatePolicy" target="_blank">
          <v-icon
            icon="mdi-open-in-new"
            size="24"
            class="icon-green"
            color="grey-darken-2"
          />
        </a>
      </div>
      <div style="width: 30px">
        <v-btn
          variant="text"
          :rounded="0"
          icon=""
          style="height: 30px; width: 30px"
          class="icon-red"
          color="grey-darken-2"
          @click="emits('delete')"
        >
          <v-icon icon="mdi-delete-outline" size="24" />
        </v-btn>
      </div>
    </div>
    <div v-else>
      <p class="text-body-2">{{ $t('corporate.terms.empty') }}</p>
      <p class="text-caption">{{ $t('events.maximumSize') }}</p>
    </div>
  </div>
  <div v-if="isMobile" class="w-100 d-flex mb-n4 mt-1">
    <Button
      class="align-self-center primaryOutline w-100"
      style="height: 28px"
      @click="emits('open')"
    >
      {{ $t('corporate.detail.appendTerms') }}
    </Button>
    <input
      id="inputFileTerms"
      type="file"
      name="inputFileTerms"
      accept="application/pdf"
      class="d-none"
      @change="handleFileChange"
    />
  </div>
</template>
